<template>
  <v-date-picker
    :input-props='{class: "base-datepicker"}'
    :masks="masks"
    v-model="localModel"
  />
</template>

<script>
import moment from 'moment'

export default {
  name: 'BaseDatePicker',
  props: {
    value: { type: [Date, String], default: moment()},
    masks: { type: Object, default: () => {} }
  },
  model: {
    prop: 'value',
    event: 'update:value'
  },
  computed: {
    localModel: {
      get() {
        return moment(this.value).toDate()
      },
      set(v) {
        this.$emit('update:value', moment(v).format('YYYY-MM-DD'))
      }
    }
  }
}
</script>

<style>
.base-datepicker {
  width: 100%;
  height: 35px;
  padding-left: 10px;
  border: 1px solid #CCD4E0;
  border-radius: 5px;
  box-sizing: border-box;
}
</style>
